export default __webpack_public_path__ + "static/media/mindtree.30749a7d.png";